/** ISO2 → English country name, client-safe (native Intl, no table shipped). */
let names: Intl.DisplayNames | null = null;
// Keep in step with NAME_OVERRIDE in scripts/build-gazetteer.mjs.
const OVERRIDE: Record<string, string> = {
  TR: "Türkiye", CZ: "Czechia", HK: "Hong Kong", MO: "Macau",
  CD: "DR Congo", CG: "Congo", MM: "Myanmar", PS: "Palestine",
};

export function countryLabel(iso: string): string {
  names ??= new Intl.DisplayNames(["en"], { type: "region" });
  return OVERRIDE[iso] ?? names.of(iso) ?? iso;
}
